import React, { useEffect, useState } from 'react';
import { projectsAPI } from '../utils/api';
import { GitCommit, Loader2 } from 'lucide-react';

export default function GitHistory({ projectId }) {
  const [commits, setCommits] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    if (!projectId) return;
    loadGitLog();
  }, [projectId]);

  const loadGitLog = async () => {
    try {
      const res = await projectsAPI.gitLog(projectId);
      setCommits(res.data.commits || res.data || []);
    } catch {
      setCommits([]);
    } finally {
      setLoading(false);
    }
  };

  if (loading) {
    return (
      <div className="flex items-center justify-center py-12">
        <Loader2 className="w-5 h-5 animate-spin text-muted-foreground" />
      </div>
    );
  }

  if (commits.length === 0) {
    return (
      <div className="text-center py-12 text-muted-foreground text-sm">
        Aucun historique Git disponible
      </div>
    );
  }

  return (
    <div className="divide-y divide-border">
      {commits.map((commit, i) => (
        <div key={commit.hash || i} className="flex items-start gap-3 px-4 py-3">
          <div className="pt-0.5">
            <GitCommit className="w-4 h-4 text-muted-foreground" />
          </div>
          <div className="flex-1 min-w-0">
            <p className="text-sm font-medium text-foreground">
              {commit.message || commit.subject}
            </p>
            <div className="flex items-center gap-3 mt-1 text-xs text-muted-foreground">
              <code className="bg-muted px-1.5 py-0.5 rounded text-[10px]">
                {(commit.hash || commit.sha || '').substring(0, 7)}
              </code>
              {commit.date && (
                <span>{new Date(commit.date).toLocaleString('fr-FR')}</span>
              )}
              {commit.author && <span>{commit.author}</span>}
            </div>
          </div>
        </div>
      ))}
    </div>
  );
}
